// Some filter options carry a `${path.to.value}` template instead of a static name (e.g. the
// Initiator filter's Organisation/Team options, which need the real agency/team name) - resolved
// by walking the dot-path against global state. Shared by every place that reads an option's name:
// the popup/pill-bar display (CommonFilter.jsx), hash generation (filtersHashes.js), and hash
// parsing back into selected state on load (useCompileInitialFilters.js) all have to resolve it
// the same way, or the hash written on selection won't match the hash read back on page load.
const resolveDynamicFilterName = (name, state) => {
  if (typeof name !== 'string' || !name.startsWith('${') || !name.endsWith('}')) {
    return name;
  }
  const path = name.slice(2, -1);
  let value = state;
  for (const part of path.split('.')) {
    value = value?.[part];
    if (value === undefined || value === null) {
      return '';
    }
  }
  return value;
};

export default resolveDynamicFilterName;
